<template>
  <section v-if="list.length" class="mt-5">
    <div class="row no-gutters">
      <div class="col pl-3 list-heading">
        {{ $t('reports.customers-reports.reservations-count') }}
      </div>
      <div class="col pl-3 list-heading">
        {{ $t('reports.customers-reports.customer') }}
      </div>
      <div class="col pl-3 list-heading">
        {{ $t('reports.customers-reports.sale-price') }}
      </div>
      <div class="col pl-3 list-heading">
        {{ $t('reports.customers-reports.paid-price') }}
      </div>
    </div>
    <ul class="row input-table mt-2">
      <reports-customer-reports-list-item
        v-for="(report, index) in list"
        :key="index"
        :item="report"
      ></reports-customer-reports-list-item>
    </ul>
  </section>
</template>
<script>
export default {
  props: {
    list: {
      default: () => [],
      type: Array,
      required: false
    }
  }
}
</script>

<style scoped>
.list-heading {
  font-family: 'Open Sans Bold';
  font-size: 14px;
  color: #767676;
}
</style>



// WEBPACK FOOTER //
// src/components/reports/customer-reports/List.vue